<script>
    import { processNonconformityStore, appStateStore } from "./store.js";
    import { onMount, createEventDispatcher } from "svelte";
    import * as api from "../../utiles/api.js";

    const dispatch = createEventDispatcher();

    function openScanner() {
        dispatch("openScanner");
    }

    let tableContainer;

    async function handleRowClick(item) {
        processNonconformityStore.update((s) => ({ ...s, selectedItem: item }));

        try {
            const params = new URLSearchParams({
                bplc_code: item.bplc_code || "01",
                prdctn_plan_no: item.prdctn_plan_no,
                odr: item.odr,
            });

            const response = await api.get(
                `process-nonconformity/detail?${params.toString()}`,
            );
            if (response && response.data) {
                processNonconformityStore.update((s) => ({
                    ...s,
                    details: response.data,
                }));
            }
        } catch (err) {
            console.error("Error fetching detail:", err);
        }

        appStateStore.set({ currentView: "detail", selectedId: item.id });
    }

    onMount(() => {
        if (tableContainer && $processNonconformityStore.scrollPos) {
            tableContainer.scrollTop = $processNonconformityStore.scrollPos;
        }
    });

    function handleScroll(e) {
        processNonconformityStore.update((s) => ({
            ...s,
            scrollPos: e.target.scrollTop,
        }));
    }
</script>

<div class="pane list-container">
    <div class="pane-header">
        <h2>
            📋 공정부적합 리스트
            <span class="total-badge">
                총 {$processNonconformityStore.list.length}건
            </span>
        </h2>
        <div class="header-actions">
            <button class="back-link btn-scan" on:click={openScanner}>🔍 SCAN</button>
        </div>
    </div>
    <div
        class="table-scroll"
        bind:this={tableContainer}
        on:scroll={handleScroll}
    >
        <table class="mes-table">
            <thead>
                <tr>
                    <th>No</th>
                    <th>LOT번호</th>
                    <th>생산계획번호</th>
                    <th>회차</th>
                    <th>품목코드</th>
                    <th>품목명</th>
                    <th>규격번호</th>
                    <th>모델번호</th>
                    <th>도면번호</th>
                    <th>검사일자</th>
                    <th>제형</th>
                    <th>제조번호</th>
                    <th>검사자사번</th>
                    <th>검사자명</th>
                    <th>조치결과</th>
                    <th>비고</th>
                </tr>
            </thead>
            <tbody>
                {#if $processNonconformityStore.list.length === 0}
                    <tr>
                        <td colspan="16" class="no-data">
                            조회된 데이터가 없습니다.
                        </td>
                    </tr>
                {:else}
                    {#each $processNonconformityStore.list as item, i}
                        <tr
                            class:selected={$processNonconformityStore
                                .selectedItem?.id === item.id}
                            on:click={() => handleRowClick(item)}
                        >
                            <td>{i + 1}</td>
                            <td class="sticky-col">{item.lot_no}</td>
                            <td>{item.prdctn_plan_no}</td>
                            <td>{item.odr}</td>
                            <td>{item.item_code}</td>
                            <td class="text-left">{item.item_nm}</td>
                            <td>{item.stndrd || "-"}</td>
                            <td>{item.modl_nm || "-"}</td>
                            <td>{item.doc_no || "-"}</td>
                            <td>{item.date}</td>
                            <td>{item.fom || "-"}</td>
                            <td>{item.mnfctur_no || "-"}</td>
                            <td>{item.inspct_empno}</td>
                            <td>{item.korean_nm || "-"}</td>
                            <td>
                                {#if item.action_result === '조치완료'}
                                    <span class="badge completed">조치완료</span>
                                {:else if item.action_result === '조치중'}
                                    <span class="badge in-progress">조치중</span>
                                {:else}
                                    <span class="badge no-action">미조치</span>
                                {/if}
                            </td>
                            <td class="text-left">{item.rm || ""}</td>
                        </tr>
                    {/each}
                {/if}
            </tbody>
        </table>
    </div>
</div>

<style>
    .pane {
        flex: 1;
        background: white;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .pane-header {
        padding: 0 12px;
        background: #f8fafc;
        border-bottom: 1px solid #f1f5f9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 42px;
        flex-shrink: 0;
    }
    .pane-header h2 {
        font-size: 0.8rem;
        margin: 0;
        font-weight: 800;
        color: #475569;
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .total-badge {
        font-size: 0.7rem;
        background: #e2e8f0;
        padding: 2px 8px;
        border-radius: 10px;
        color: #64748b;
    }
    .table-scroll {
        flex: 1;
        overflow: auto;
    }
    .mes-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.85rem;
        min-width: 1500px;
    }
    .mes-table th {
        position: sticky;
        top: 0;
        background: #f8fafc;
        padding: 10px 12px;
        text-align: center;
        font-weight: 700;
        color: #64748b;
        border-bottom: 2px solid #e2e8f0;
        z-index: 10;
        white-space: nowrap;
    }
    .mes-table td {
        padding: 10px 12px;
        text-align: center;
        color: #1e293b;
        border-bottom: 1px solid #f1f5f9;
        white-space: nowrap;
    }
    .mes-table tr:hover {
        background: #f1f5f9;
        cursor: pointer;
    }
    .mes-table tr.selected {
        background: #e0f2fe;
    }
    .text-left {
        text-align: left !important;
    }
    .no-data {
        padding: 40px !important;
        color: #94a3b8;
        font-weight: 500;
    }
    .badge {
        padding: 4px 10px;
        border-radius: 20px;
        font-size: 0.75rem;
        font-weight: 700;
    }

    .badge.no-action {
        background: #fee2e2;
        color: #ef4444;
    }
    .badge.in-progress {
        background: #fef3c7;
        color: #d97706;
    }
    .badge.completed {
        background: #dcfce7;
        color: #16a34a;
    }
    .header-actions {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .back-link {
        background: #ffffff;
        color: #3b82f6;
        border: 1.5px solid #bfdbfe;
        padding: 5px 12px;
        border-radius: 20px;
        font-weight: 800;
        font-size: 0.72rem;
        cursor: pointer;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
    }
    .back-link.btn-scan {
        background: #10b981;
        color: white;
        border-color: #10b981;
    }
    .back-link.btn-scan:hover {
        background: #059669;
        transform: translateY(-1px);
    }
</style>
